<template>
  <div style="padding: 10px">
    <x-table
      ref="list"
      listApi="biz.warehouse.survey.info.list"
      paginationLayout="total, sizes, prev, next, jumper"
      actionFixed="right"
      emptyLabel="暂无调研单记录信息"
      :fieldList="fieldList"
      :actionList="actionList"
      :paramList="paramList"
      :defaultParams="defaultParams"
      :actionWidth="150"
    >
      <template slot="param-extra" slot-scope="scope">
        <customer-store-select
          v-model="storeGuid"
          :storehouseGuid="defaultParams.storehouseGuid"
          :multiple="false"
          :clearable="true"
        />
      </template>
      <template slot="row-info" slot-scope="scope">
        <warehouse-survey-info :surveyInfo="scope.row" />
      </template>
    </x-table>
  </div>
</template>

<script>
import customerStoreSelect from "../../../../components/business/customerStoreSelect.vue";
import warehouseSurveyInfo from "@/components/business/warehouseSurveyInfo.vue";
import surveyDetailPage from "./__arranged_survey_detail.vue";
import surveyFromPage from "./__arranged_survey_form.vue";

export default {
  components: {
    customerStoreSelect,
    warehouseSurveyInfo,
  },
  props: {
    tabName: {
      type: String,
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      return Object.assign({}, this.pageQuery, {
        storeGuid: this.storeGuid,
      });
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  methods: {
    refresh() {
      if (this.$refs.list) {
        this.$refs.list.refresh();
      }
      this.$emit("call-event", "refresh");
    },
  },
  data() {
    return {
      storeGuid: "",
      paramList: [
        {
          label: "状态",
          type: "select",
          field: ["optStatus"],
          styleValue: "width: 160px",
          options: [
            {
              label: "全部",
              value: "",
            },
            {
              label: "等待入库",
              value: "0",
            },
            {
              label: "部分入库",
              value: "1",
            },
            {
              label: "全部入库",
              value: "2",
            },
            {
              label: "已关闭的",
              value: "3",
            },
          ],
          default: "",
        },
        {
          label: "调研单号/调研单备注信息查询",
          field: ["queryValue"],
          styleValue: "width: 320px",
        },
      ],
      fieldList: [
        {
          label: "记录信息",
          minWidth: "280",
          slot: "info",
        },
      ],
      actionList: [
        {
          label: "详情",
          linkType: "primary",
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: "调研单记录详情",
              refresh: this.refresh,
              component: surveyDetailPage,
              params: {
                guid: row.guid,
                storeGuid: row.storeGuid,
              },
            });
          },
        },
        {
          label: "编辑",
          linkType: "primary",
          show: (row) => {
            return row.optStatus != 3;
          },
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: "编辑调研单信息",
              refresh: this.refresh,
              component: surveyFromPage,
              params: {
                guid: row.guid,
                storeGuid: row.storeGuid,
              },
            });
          },
        },
        {
          label: "关闭",
          linkType: "danger",
          disabled: (row) => {
            return row.inboundGoodsCount > 0 || row.optStatus == 3;
          },
          click: (row, tag, refresh) => {
            this.$confirm("确认关闭调研单？", "警告", {
              type: "error",
            }).then(() => {
              this.cancelLoading = true;
              this.requestApi(
                "biz.warehouse.survey.info.close",
                {
                  guid: row.guid,
                  storeGuid: row.storeGuid,
                },
                {
                  showError: true,
                }
              ).then(() => {
                this.refresh();
              });
            });
          },
        },
      ],
    };
  },
};
</script>
